import { DataField } from '../../interfaces/AppProps';
import replaceSymbolsAsPerDmn from './replaceSymbolsAsPerDmn';

const convertToDMN = (dataEntries: DataField, ruleName): string => {
  if (!Array.isArray(dataEntries?.data) || dataEntries?.data.length === 0) {
    return '';
  }
  if (
    !Array.isArray(dataEntries?.inputFields) ||
    dataEntries?.inputFields.length === 0
  ) {
    console.warn(
      'inputEntryFormFields is not defined or is empty. Ensure it is properly initialized.'
    );
    return '';
  }

  if (
    !Array.isArray(dataEntries?.outputFields) ||
    dataEntries?.outputFields.length === 0
  ) {
    console.warn(
      'outputEntryFormFields is not defined or is empty. Ensure it is properly initialized.'
    );
    return ''; // Or handle the error as appropriate
  }

  const inputKeys = dataEntries?.inputFields?.map((item) => item?.name);
  const outputKeys = dataEntries?.outputFields?.map((item) => item?.name);

  // Helper function to create input XML
  const createInputXml = (key: string, index: number): string => {

    const inputId = `Input_${index + 1}`;
    const expressionId = `InputExpression_${index + 1}`;
    console.log(dataEntries?.inputFields, key, 'asddasdasdasdasd')

    return `
        <input id="${inputId}" label="${key}">
          <inputExpression id="${expressionId}" typeRef="${dataEntries?.inputFields?.filter((item) => item?.name === key)[0]?.type}">
            <text>${key}</text>
          </inputExpression>
        </input>`;
  };

  // Helper function to create output XML
  const createOutputXml = (key: string, index: number): string => {

    const outputId = `Output_${index + 1}`;
    return `
        <output id="${outputId}" label="${key}" name="${key}" typeRef="${dataEntries?.outputFields?.filter((item) => item?.name === key)[0]?.type}"/>`;
  };

  const generateUUID = (): string => {
    const randomNum = Math.floor(Math.random() * 10000000000000000); // Generate a random number
    return `D_${randomNum.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '_')}`.slice(0, 16);
  };

  const uuid = generateUUID();
  console.log(uuid);

  // Build DMN XML
  let dmn = `<?xml version="1.0" encoding="UTF-8"?>
      <definitions xmlns="https://www.omg.org/spec/DMN/20191111/MODEL/"
                  xmlns:dmndi="https://www.omg.org/spec/DMN/20191111/DMNDI/"
                  xmlns:dc="http://www.omg.org/spec/DMN/20180521/DC/"
                  xmlns:modeler="http://camunda.org/schema/modeler/1.0"
                  id="Definitions_1v3pcnq"
                  name="${ruleName || ''}"
                  namespace="http://camunda.org/schema/1.0/dmn"
                  exporter="Camunda Modeler"
                  exporterVersion="5.16.0"
                  modeler:executionPlatform="Camunda Cloud"
                  modeler:executionPlatformVersion="8.0.0">
        <decision id="${uuid}" name="${ruleName?.toString()}">
          <decisionTable id="DecisionTable_0qmgrvk" hitPolicy="FIRST">
            ${inputKeys.map(createInputXml).join('')}
            ${outputKeys.map(createOutputXml).join('')}
            ${dataEntries?.data
      .map((entry: any, index: number) => {
        const ruleId = `DecisionRule_${index}`;
        return `
                <rule id="${ruleId}">
                  ${inputKeys
            .map((key: string, idx: number) => {
            
              const value = entry[key as keyof any];
              const dataType = dataEntries?.inputFields?.filter((item) => item?.name === key)[0]?.type;
                console.log(key,value,dataType,'checkingKeysasdasd')
              return `
                      <inputEntry id="UnaryTests_${index}_${idx + 1}">
                        ${replaceSymbolsAsPerDmn(value,dataType,'input')}
                      </inputEntry>`;
            })
            .join('')}
                  ${outputKeys.map((key: string, idx: number) => {
              return `
                      <outputEntry id="LiteralExpression_${index}_${idx}">
                        ${replaceSymbolsAsPerDmn(entry[key as keyof any], dataEntries?.outputFields?.filter((item) => item?.name === key)[0]?.type,'output')}
                      </outputEntry>`;
            }).join('')}
                </rule>`;
      })
      .join('')}
          </decisionTable>
        </decision>
        <dmndi:DMNDI>
          <dmndi:DMNDiagram>
            <dmndi:DMNShape dmnElementRef="${uuid.toString()}">
              <dc:Bounds height="80" width="180" x="160" y="100" />
            </dmndi:DMNShape>
          </dmndi:DMNDiagram>
        </dmndi:DMNDI>
      </definitions>`;

  console.log(dmn, 'xmlString');
  return dmn;
};

export default convertToDMN;
